/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import AliceCarousel from 'react-alice-carousel';
import { Breadcrumb, Image, Embed, Icon, Button, Loader, Label, Modal } from  'semantic-ui-react'
import Moment from 'react-moment'
import Img from 'react-image'

import { fetchProduct, addProductWishlist, removeProductWishlist } from 'ducks/product'
import { 
  NotFoundContainer,
  CoverImgContainer,
  MediaContainer,
  AttachFileContainer,
  ItemNotFoundContainer
} from './styled'  
import { MainBodyContent} from '../../../components'
import StdForm from '../StdForm'
import emptyStateImage from 'assets/images/emptyBox.svg'
import noPreviewImage from 'assets/images/box.svg'
import { productPath } from 'routes'
import { currencyNumberFormat, discountCalculator } from 'core/utilities'
import { StatusTag, FileUploadCell } from 'components'
import CompareChart from '../ComparisonTable'

import "react-alice-carousel/lib/alice-carousel.css";
import 'react-table/react-table.css'

const ProductDetails = (props) => {
  useEffect(() => {
    props.fetchProduct(props.match.params.productId)
  }, [])

  const {product, history, wishlist, addProductWishlist, removeProductWishlist} = props

  const [open, setOpen] = React.useState(false)

  const getVendorName = () => {
    if (product.vendor) {
      return (product.vendor.code ? `${product.vendor.code} | ` : '') + product.vendor.nameTh
    }

    return '';
  }

  const getStatusCodeStyle = (status) => {
    return status === 'Published' ? 4 : 0
  }

  const onHideCallback = (productId) => {
    removeProductWishlist(productId)
  }

  const features = [
    'Status',
    'Product Code',
    'Product Name',
    'Brand',
    'Model',
    'Vendor',
    'Material',
    'Size',
    'Color',
    'Price List',
    'Discount',
    'Price After Discount',
    'Gross Weight',
    'Net Weight',
    'Unit',
    'Minimum Order',
    'Delivery Time',
  ];

  const RenderProductDes = ()=> (
    <StdForm title='Product Description'>
      <div style={{display:'flex'}}>
        <div style={{display:'flex',flex:1,flexDirection:'column'}}>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Status : </div>
            <div style={{flex:3}}>
              <StatusTag status={getStatusCodeStyle(product.status)} statusName={product.status}>
                {product.status}
              </StatusTag>
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Product Code : </div>
            <div style={{flex:3}}>{product.productCode}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Product Name : </div>
            <div style={{flex:3}}>{product.productName}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Brand : </div>
            <div style={{flex:3}}>{product.brand}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Model : </div>
            <div style={{flex:3}}>{product.productModel}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Vendor : </div>
            <div style={{flex:3}}>{ getVendorName() }</div>
          </div>
          {/* <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Category : </div>
            <div style={{flex:3}}>{product.categoryName}</div>
          </div> */}
          {/* <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Sub Category : </div>
            <div style={{flex:3}}>{product.subCategoryName}</div>
          </div> */}
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Material : </div>
            <div style={{flex:3}}>{product.material}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Size : </div>
            <div style={{flex:3}}>{product.size}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Color : </div>
            <div style={{flex:3}}>{product.color}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Currency : </div>
            <div style={{flex:3}}>{product.currencyCode}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Price List : </div>
            <div style={{flex:3}}>{currencyNumberFormat(product.price, product.currencyCode, 2)}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Discount : </div>
            <div style={{flex:3}}>
              {
                product.discountType === 'percent' ? `${product.discount} %`: currencyNumberFormat(product.discount, product.currencyCode, 2)
              }
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Price After Discount : </div>
            <div style={{flex:3}}>
              {
                currencyNumberFormat(
                  discountCalculator(
                    product.price, product.discount, product.discountType
                  ), 
                  product.currencyCode, 
                  2
                )
              }
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Segments : </div>
            <div style={{flex:3}}>
              {product.segments.map(segment => <Label>{segment.name}</Label>)}
            </div>
          </div>
          <div style={{display:'flex', justifyContent:'flex-start', marginTop: '2px'}}>
            <div style={{flex:1}}>MQDC Projects : </div>
            <div style={{flex:3}}>
              {product.mqdcProjects.map(project => <Label>{project.name}</Label>)}
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Gross Weight : </div>
            <div style={{flex:3}}>{`${product.grossWeight || ''} ${product.weightUnit || ''}`}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Net Weight : </div>
            <div style={{flex:3}}>{`${product.netWeight || ''} ${product.weightUnit || ''}`}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Unit : </div>
            <div style={{flex:3}}>{product.unitCode}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Minimum Order : </div>
            <div style={{flex:3}}>{product.minimumOrder}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Delivery Time : </div>
            <div style={{flex:3}}>{product.deliveryTime}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Created Date : </div>
            <div style={{flex:3}}><Moment format="DD MMM YYYY">{product.createdDate}</Moment></div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start'}}>
            <div style={{flex:1}}>Modified Date : </div>
            <div style={{flex:3}}><Moment format="DD MMM YYYY">{product.modifiedDate}</Moment></div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start', marginTop:10}}>
            <div style={{flex:1}}>Description : </div>
            <div style={{flex:3}}>{product.description}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start', marginTop:10}}>
            <div style={{flex:1}}>Remark : </div>
            <div style={{flex:3}}>{product.remark}</div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-start', marginTop:10}}>
            <div style={{flex:1}}></div>
            <div style={{flex:3}}>
            <Button 
              icon 
              labelPosition='left' 
              size='mini' 
              onClick={() => addProductWishlist(product)}
              disabled={wishlist.some(p => p.id === product.id)}
            >
              <Icon name='star' />
              Add to wishlist
            </Button>
            </div>
          </div>
        </div>
        <CoverImgContainer>
          <div className='imgBorder notfoundImg'>
            <Img
              style={{ opacity: product.coverImageUrl ? '' : '0.4'}}
              width='200' height='200'
              src={[product.coverImageUrl, noPreviewImage]}
              loader={<Loader>Loading</Loader>}
              unloader={<Icon color='grey' size='huge' name='image'/>}
            />
          </div>
        </CoverImgContainer>
      </div>
      </StdForm>
  )

  const RenderImages = ()=> {
    const handleOnDragStart = e => e.preventDefault()

    return (
      <StdForm title='Images'>
        {
          product.attachments.filter(a => a.documentType === 'IMAGEFILES').length > 0
          ?
          <MediaContainer>
            <div style={{width:800, marginTop:10}}>
              <AliceCarousel 
                mouseDragEnabled
                responsive={{0:{items: 4}}}
                buttonsDisabled={true}
              >
                {
                  product.attachments
                    .filter(a => a.documentType === 'IMAGEFILES')
                    .map((item, index) => (
                      <div style={{display: 'flex', justifyContent: 'center'}}>
                        <Img
                          width='200' height='200'
                          src={[item.urlPath, noPreviewImage]}
                          loader={<Loader>Loading</Loader>}
                          unloader={<Icon color='grey' size='huge' name='image'/>}
                          onDragStart={handleOnDragStart}
                        />
                    </div>
                    ))
                }
              </AliceCarousel>
            </div>
          </MediaContainer>
          :
          <ItemNotFoundContainer>
            <div>
              <Image src={emptyStateImage} size='small' disabled />
            </div>
            <div className='text'>No Item Found</div>
          </ItemNotFoundContainer>
        }
      </StdForm>
    )
  }

  const RenderAttachFile = () => {
    const manualFiles = (product.attachments || []).filter(attach => attach.documentType === 'MANUALFILES');
    const catalogFiles = (product.attachments || []).filter(attach => attach.documentType === 'CATALOGFILES');
    const otherFiles = (product.attachments || []).filter(attach => attach.documentType === 'OTHERFILES');
    
    return (
      <StdForm title='Attachments'>
        {
          product.attachments.filter(a => ['MANUALFILES', 'CATALOGFILES', 'OTHERFILES'].includes(a.documentType)).length > 0 
          ?
          <AttachFileContainer>
            <div style={{width: '100%', margin: '4px'}}>
              <div style={{display: manualFiles.length > 0 ? '' : 'none'}}>Manual & Document</div>
              {
                manualFiles.map((attach) => 
                  <FileUploadCell
                    key={`attach-${attach.id}`}
                    fileName={attach.originalFilename}
                    fileSize={attach.size}
                    fileType={attach.fileType}
                    urlPath={attach.urlPath} 
                    deletable={false}
                  />
                )
              }
            </div>

            <div style={{width: '100%', margin: '4px'}}>
              <div style={{display: catalogFiles.length > 0 ? '' : 'none'}}>Catalog</div>
              {
                catalogFiles.map((attach) => 
                  <FileUploadCell
                    key={`attach-${attach.id}`}
                    fileName={attach.originalFilename}
                    fileSize={attach.size}
                    fileType={attach.fileType}
                    urlPath={attach.urlPath} 
                    deletable={false}
                  />
                )
              }
            </div>

            <div style={{width: '100%', margin: '4px'}}>
              <div style={{display: otherFiles.length > 0 ? '' : 'none'}}>Other</div>
              {
                otherFiles.map((attach) => 
                  <FileUploadCell
                    key={`attach-${attach.id}`}
                    fileName={attach.originalFilename}
                    fileSize={attach.size}
                    fileType={attach.fileType}
                    urlPath={attach.urlPath} 
                    deletable={false}
                  />
                )
              }
            </div>
          </AttachFileContainer>
          :
          <ItemNotFoundContainer>
            <Image src={emptyStateImage} size='small' disabled />
            <span className='text'>No Item Found</span>
          </ItemNotFoundContainer>
        }
      </StdForm>
    )
  }

  const RenderVideos = ()=> {
    const handleOnDragStart = e => e.preventDefault()

    return (
      <StdForm title='Videos'>
        {
          product.links.filter(a => a.linkType === 'VIDEOLINKS').length > 0 
          ?
          <MediaContainer>
            <div style={{width:500, marginTop:10}}>
              <AliceCarousel mouseDragEnabled buttonsDisabled={true}>
                {
                  product.links
                    .filter(a => a.linkType === 'VIDEOLINKS')
                    .map((item,index)=>{
                      let url = new URL(item.address);
                      let v = ''

                      if (url.hostname.includes('youtu')) {
                        v = url.searchParams.get('v')

                        if (!v) {
                          v = url.pathname
                        }

                        return <Embed onDragStart={handleOnDragStart} id={v} source='youtube' />
                      } else {
                        return <Embed onDragStart={handleOnDragStart} url={item.address} />
                      }
                    })
                }
              </AliceCarousel>
            </div>
          </MediaContainer>
          :
          <ItemNotFoundContainer>
            <Image src={emptyStateImage} size='small' disabled />
            <span className='text'>No Item Found</span>
          </ItemNotFoundContainer>
        }
      </StdForm>
    )
  }

  const RenderLinks = () => (
    <StdForm title='Image Links'>
      {
        product.links.filter(a => a.linkType === 'IMAGELINKS').length > 0
        ?
        <div>
          {
            product.links.filter(a => a.linkType === 'IMAGELINKS').map((item, index) => {
              return (
                <div>
                  <Button icon style={{marginTop: 10}} labelPosition='left' onClick={() => window.open(item.address)}>
                    <Icon name='linkify' />
                    {item.address}
                  </Button>
                </div>
              )
            })
          }
        </div>
        :
        <ItemNotFoundContainer>
          <Image src={emptyStateImage} size='small' disabled />
          <span className='text'>No Item Found</span>
        </ItemNotFoundContainer>
      }
    </StdForm>
  )

  return (
    <>
      <MainBodyContent 
        headerTitle='Product Detail'
        breadcrumbs={
          <Breadcrumb 
            icon='right angle' 
            sections={[
              { key: 'Products', content: 'Products', link: true, onClick: () => history.push(productPath) },
              { key: 'ProductDetail', content: product.productCode ? product.productCode : 'Detail', active: true }
            ]}
          />
        }
      >
        {product.iD!==0&&
        <div>
          <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
            <Link to="#" style={{margin: '10px 0'}} onClick={() => setOpen(true)}>
              <i ariaHidden={true} className='balance scale'></i>
              Your Wishlist ({wishlist.length})
            </Link>
          </div>
          <RenderProductDes />
          <RenderImages />
          <RenderAttachFile />
          <RenderVideos />
          <RenderLinks />
        </div>}
        {product.iD===0&&!props.loading&&
          <NotFoundContainer>
            <span className='text'>Product not found</span>
            <Icon size='huge' name='delete'/>
          </NotFoundContainer>
        }
      </MainBodyContent>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Modal.Header>Compare Products</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <CompareChart 
              data={wishlist} 
              features={features} 
              hideItemOption={true}
              onHide={onHideCallback}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => ({
  product: state.product.product,
  loading: state.product.loading,
  productSpecialField:state.product.productSpecialField,
  isEditedProduct: state.product.isEditedProduct,
  wishlist: state.product.wishlist,
})
const mapDispatchToProps = {
  fetchProduct,
  addProductWishlist,
  removeProductWishlist,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails)
